import ApiClient from '@package/services/src/ApiClient';
import Result, { EmptyResult } from '@package/services/src/Result';

import { AuthService } from './services';
import { GetUserRequest, User } from './types';

export default class AuthApiService implements AuthService {
  public constructor(protected apiClient: ApiClient) {}

  public async getUser(request?: GetUserRequest): Promise<Result<User | null>> {
    try {
      const res = await this.apiClient.get('/shoppingCart/userInfo', {
        credentials: request?.cookie ? 'include' : undefined,
        headers: request?.cookie ? { Cookie: request.cookie } : undefined,
      });
      const user: User = await res.json();

      const userFullName = user.fullName.split(' ');
      const mappedUser: User = {
        ...user,
        firstName: userFullName[1],
        lastName: userFullName[0],
      };

      return new Result(mappedUser);
    } catch (error) {
      console.error('Cant get user info', error);
      return new Result(null);
    }
  }

  public async logout(): Promise<EmptyResult> {
    await this.apiClient.post('/shoppingCart/logout');

    return new EmptyResult();
  }
}
